import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

// Default theme colors (Commercio Network branding)
// These will be updated from runtime config after it loads
export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {
      light: {
        primary: '#0082c3', // Commercio blue (default)
        background: colors.grey.lighten5,
        backgroundFooter: colors.blueGrey.lighten5,
      },
      dark: {
        primary: '#0082c3', // Commercio blue (default)
        secondary: colors.grey.lighten4,
      },
    },
  },
});
